import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AppConfigManagerService} from './app-config-manager.service';
import {AVAILABLE_LANGUAGES_CONST} from '../../Shared/Const/languages.const';

@Injectable({
  providedIn: 'root'
})
export class LanguageManagerService {

  public currentLanguage: string = 'es';
  public readonly availableLanguages = AVAILABLE_LANGUAGES_CONST;

  constructor(
    protected translate: TranslateService,
    protected appConfigManager: AppConfigManagerService
  ) {
  }


  /**
   * Traducir aplicación
   *
   */
  async translateApp(savedLanguage?: string) {
    let configLanguage: string = 'es';

    if (!savedLanguage) {
      await this.appConfigManager.getAppConfig();
      configLanguage = this.appConfigManager.appConfig?.language;
    }

    const language: string = savedLanguage ?? configLanguage ?? 'es';

    this.currentLanguage = this.isLanguageAvailable(language) ? language : 'es';
    this.translate.use(this.currentLanguage);
  }


  /**
   * Cambiar el idioma en la app
   *
   */
  setLanguage(languageCode: string) {
    this.currentLanguage = languageCode;
    this.translate.use(languageCode);

    if (!this.appConfigManager.appConfig) {
      return;
    }

    this.appConfigManager.appConfig.language = languageCode;
    this.appConfigManager.saveAppConfig();
  }


  /**
   * Comprobar si el idioma está disponible
   *
   */
  isLanguageAvailable(languageCode: string): boolean {
    return this.availableLanguages.some((lang) => lang.code === languageCode);
  }


  /**
   * Obtener el nombre del idioma seleccionado
   *
   */
  getCurrentLanguageName(): string {
    const lang = this.availableLanguages.find(l => l.code === this.currentLanguage);
    return lang ? lang.name : 'Español';
  }

}
